import React, { Component } from 'react'
import { connect } from 'react-redux'
import StartupActions from '../reducers/startup/StartupRedux'
import Router from '../Router/index';

class RootContainer extends Component {
    componentDidMount() {
        this.props.startup()
    }

    render () {
        return <Router/>
    }
}

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
    startup: () => dispatch(StartupActions.startup())
});

export default connect(null, mapDispatchToProps)(RootContainer)
